"use strict";

var _slicedToArray = require("/home/runner/work/es-product-index/es-product-index/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/home/runner/work/es-product-index/es-product-index/node_modules/@babel/runtime/helpers/classCallCheck");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var oss_json_1 = __importDefault(require("../../fixtures/regexes/oss.json"));

var version_1 = require("../../utils/version");

var variable_replacement_1 = require("../../utils/variable-replacement");

var user_agent_1 = require("../../utils/user-agent");

var operating_system_json_1 = __importDefault(require("./fixtures/operating-system.json"));

var desktopOsArray = ["AmigaOS", "IBM", "GNU/Linux", "Mac", "Unix", "Windows", "BeOS", "Chrome OS"];
var shortOsNames = operating_system_json_1.default.operatingSystem;
var osFamilies = operating_system_json_1.default.osFamilies;

var OperatingSystemParser = function OperatingSystemParser(options) {
  var _this = this;

  _classCallCheck(this, OperatingSystemParser);

  this.options = {
    versionTruncation: 1
  };

  this.parse = function (userAgent) {
    var result = {
      name: "",
      version: "",
      platform: _this.parsePlatform(userAgent)
    };

    var _iterator = _createForOfIteratorHelper(oss_json_1.default),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var operatingSystem = _step.value;
        var match = user_agent_1.userAgentParser(operatingSystem.regex, userAgent);
        if (!match) continue;
        result.name = variable_replacement_1.variableReplacement(operatingSystem.name, match);
        result.version = version_1.formatVersion(variable_replacement_1.variableReplacement(operatingSystem.version, match), _this.options.versionTruncation);

        if (result.name === "lubuntu") {
          result.name = "Lubuntu";
        }

        if (result.name === "debian") {
          result.name = "Debian";
        }

        if (result.name === "YunOS") {
          result.name = "YunOs";
        }

        return result;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return null;
  };

  this.parsePlatform = function (userAgent) {
    if (user_agent_1.userAgentParser("arm|aarch64|Watch ?OS|Watch1,[12]", userAgent)) {
      return "ARM";
    }

    if (user_agent_1.userAgentParser("WOW64|x64|win64|amd64|x86_64", userAgent)) {
      return "x64";
    }

    if (user_agent_1.userAgentParser("i[0-9]86|i86pc", userAgent)) {
      return "x86";
    }

    if (user_agent_1.userAgentParser("mips", userAgent)) {
      return "MIPS";
    }

    if (user_agent_1.userAgentParser("sh4", userAgent)) {
      return "SuperH";
    }

    return "";
  };

  this.options = Object.assign(Object.assign({}, this.options), options);
};

exports.default = OperatingSystemParser;

OperatingSystemParser.getDesktopOsArray = function () {
  return desktopOsArray;
};

OperatingSystemParser.getOsFamily = function (osName) {
  var osShortName = OperatingSystemParser.getOsShortName(osName);

  for (var _i = 0, _Object$entries = Object.entries(osFamilies); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
        osFamily = _Object$entries$_i[0],
        shortNames = _Object$entries$_i[1];

    if (shortNames.includes(osShortName)) {
      return osFamily;
    }
  }

  return "";
};

OperatingSystemParser.getOsShortName = function (osName) {
  for (var _i2 = 0, _Object$entries2 = Object.entries(shortOsNames); _i2 < _Object$entries2.length; _i2++) {
    var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i2], 2),
        shortName = _Object$entries2$_i[0],
        name = _Object$entries2$_i[1];

    if (name === osName) return shortName;
  }

  return "";
};